import { Injectable } from '@angular/core';
import { SESSION_STORAGE_KEY } from '../../features/auth/shared/auth-state';
import { JwtUtil } from '../utils/jwt.util';

@Injectable({ providedIn: 'root' })
export class TokenService {
  getAccessToken(): string | null {
    try {
      const raw = localStorage.getItem(SESSION_STORAGE_KEY);
      if (!raw) return null;
      const token = (JSON.parse(raw) as { accessToken?: string | null }).accessToken ?? null;
      // El login es simulado: su token no es válido para la API real y
      // provocaría 401 que revocan la sesión. No se adjunta a peticiones.
      return token && !JwtUtil.isSimulated(token) ? token : null;
    } catch {
      return null;
    }
  }
}
